import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const useDynamicQuery = (params) => {
    const ref = useRef({});
    const history = useHistory();
    const keys = Object.keys(ref.current);

    if (!keys.every(k => ref.current[k] === params[k]) ||
        !Object.keys(params).every(k => keys.includes(k))) {
        ref.current = params;
    }

    params = ref.current;
    
    useEffect(() => {
        const keys = Object.keys(params);
        const searchParams = new URLSearchParams();
        keys.filter(k => !!params[k]).forEach(k => searchParams.append(k, params[k]))
        history.replace({ search: searchParams.toString() });
    }, [history, params]);

    return null;
}

export const useQueryParams = () => {
    const query = new URLSearchParams(useLocation().search);
    const keys = [...query.keys()];
    return keys.reduce((obj, k) => (obj[k] = query.get(k)) && obj, {});
}